import { UI_STRINGS } from '../functions/language/uistrings';
import { Sector } from '../model/sector';
import { SectorColours } from './sector-colours';

//Note this is what is currently persisted in the database, so it should not be changed
export const PurpleColourId = 'purple';

export const DiagramColours = [
  {
    id: 'transport-green',
    name: UI_STRINGS.COLOURS.GREEN,
    colour: SectorColours.transportColour,
    sector: Sector.Transport,
  },
  {
    id: 'industry-blue',
    name: UI_STRINGS.COLOURS.BLUE,
    colour: SectorColours.industryColour,
    sector: Sector.Industry,
  },
  {
    id: 'agriculture-orange',
    name: UI_STRINGS.COLOURS.ORANGE,
    colour: SectorColours.agricultureColour,
    sector: Sector.Agriculture,
  },
  {
    id: 'energy-yellow',
    name: UI_STRINGS.COLOURS.YELLOW,
    colour: SectorColours.energyColour,
    sector: Sector.Energy,
  },
  {
    id: 'other-red',
    name: UI_STRINGS.COLOURS.PINK,
    colour: SectorColours.otherColour,
    sector: Sector.Other,
  },
  {
    id: 'mixed-teal',
    name: UI_STRINGS.COLOURS.TEAL,
    colour: SectorColours.unknownColour,
    sector: Sector.None,
  },
  {
    id: PurpleColourId,
    name: UI_STRINGS.COLOURS.PURPLE,
  },
];
